import { FaceSmile, Home, Menu, Phone, FileList } from '@/lib/icons'
import Link from 'next/link'

const DisabledLinks = () => {
    return (
        <nav className="text-sm sm:text-base text-light/50 border border-light/20 w-max py-2 px-3 sm:py-2.5 sm:px-5 rounded-full font-medium capitalize items-center flex gap-1.5 sm:gap-2 justify-center fixed top-3.5 right-1/2 translate-x-1/2 bg-dark/80 backdrop-blur-sm z-50">
            <Link href="/" className="text-light/50 hover:text-light flex-center" aria-label='Go to the home page'>
                <Home className="inline-block w-4.5 h-4.5 md:w-5 md:h-5 mr-0.5" />
                Home
            </Link>
            <Link href="/about" className="text-light/50 hover:text-light flex-center" aria-label='Go to the contact page'>
                <FaceSmile className="inline-block w-4 h-4 md:w-4.5 md:h-4.5 mr-0.5" />
                About
            </Link>
            <Link href="/works" className="text-light/50 hover:text-light flex-center" aria-label='Go to the works page'>
                <Menu className="inline-block w-4.5 h-4.5 md:w-5 md:h-5 mr-0.5" />
                Works
            </Link >
            <Link href="/categories/all" className="flex-center hidden xs:flex text-light/50 hover:text-light" aria-label='Go to the Blogs'>
                <FileList className="inline-block w-4.5 h-4.5 md:w-5 md:h-5 mr-0.5" />
                Blogs
            </Link >
            <Link href="/contact" className="text-light/50 hover:text-light flex-center" aria-label='Go to the contact page' >
                <Phone className="inline-block -scale-x-100 w-4.5 h-4.5 md:w-5 md:h-5 mr-0.5" />
                Contact
            </Link >
        </nav >
    )
}

export default DisabledLinks